import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TypeActeMedicalEPrescription } from 'src/app/utils/enums/type-acte-medical-eprescription.enum';
import { LigneActe } from 'src/app/utils/interfaces/new/ligne-acte';
import { Tools } from 'src/app/utils/tools';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-add-acte',
  templateUrl: './add-acte.fragment.html',
  styleUrls: [
    './add-acte.fragment.scss',
    '../modal.fragment.scss'
  ]
})
export class AddActeFragment implements OnInit {

  @ViewChild('modalBody') public modalBody: ElementRef;
  @ViewChild('outsideModal') public outsideModal: ElementRef;

  public modalTitle: string = 'Ajout d\'acte médical';
  public formGroup: FormGroup;
  public typesActes = TypeActeMedicalEPrescription;
  // Set directement lors de l'ouverture du modal
  public typeActe: TypeActeMedicalEPrescription = TypeActeMedicalEPrescription.BIO
  public currentActe: LigneActe;

  @Output() public closeEmitter = new EventEmitter();
  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody.nativeElement.contains(event.target) && this.outsideModal.nativeElement.contains(event.target)) {
      this.closeAddActeModal();
    }
  }

  constructor(
    private _formBuilder: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      detail: [this.currentActe ? this.currentActe.detail : '', Validators.required],
      nb_renouvellement: [this.currentActe ? this.currentActe.nb_renouvellement : 0],
      freq_renouvellement: [this.currentActe ? this.currentActe.freq_renouvellement : 0],
      ald: [this.currentActe ? this.currentActe.ald : false],
      professionnel: [this.currentActe ? this.currentActe.professionnel : false],
      prevention: [this.currentActe ? this.currentActe.prevention : false],
      non_remboursable: [this.currentActe ? this.currentActe.non_remboursable : false],
      hors_nomenclature: [this.currentActe ? this.currentActe.hors_nomenclature : false],
      ajeun: [this.currentActe ? this.currentActe.ajeun : false],
      donnees_medicales: [this.currentActe ? this.currentActe.donnees_medicales : ''],
    });

    if (this.currentActe) {
      this.modalTitle = 'Modification d\'acte médical';
    }

    this.subscribeToControlChanges('ald', ['professionnel', 'prevention', 'non_remboursable', 'hors_nomenclature']);
    this.subscribeToControlChanges('professionnel', ['ald', 'prevention']);
    this.subscribeToControlChanges('prevention', ['ald', 'professionnel']);
    this.subscribeToControlChanges('non_remboursable', ['ald', 'hors_nomenclature']);
    this.subscribeToControlChanges('hors_nomenclature', ['ald', 'non_remboursable']);
  }

  public getTitleStringType() {
    return Tools.capitalizeString(
        Tools.getKeyStringFromEnumValue(this.typeActe, TypeActeMedicalEPrescription)
      );
  }

  public async onSubmit() {
    this.formGroup.markAllAsTouched();

    let object: Partial<LigneActe> = {
      detail: this.formGroup.get('detail').value,
      nb_renouvellement: this._toNumber(this.formGroup.get('nb_renouvellement').value),
      ald: this.formGroup.get('ald').value,
      professionnel: this.formGroup.get('professionnel').value,
      prevention: this.formGroup.get('prevention').value,
      non_remboursable: this.formGroup.get('non_remboursable').value,
      hors_nomenclature: this.formGroup.get('hors_nomenclature').value,
      order: this.currentActe ? this.currentActe.order : undefined,
    }
    if (this.formGroup.get('donnees_medicales').value) {
      object.donnees_medicales=this.formGroup.get('donnees_medicales').value
    }
    if (this.typeActe === TypeActeMedicalEPrescription.BIO) {
      object.freq_renouvellement=this._toNumber(this.formGroup.get('freq_renouvellement').value),
      object.ajeun=this.formGroup.get('ajeun').value
    }

    if (this.formGroup.valid) {
      this.closeAddActeModal(object);
    }
  }


  public closeAddActeModal(object?: Partial<LigneActe>): void {
    if (object) {
      this.closeEmitter.emit(object);
    } else {
      this.closeEmitter.emit(null);
    }
  }

  public stopPropagation(event): void {
    event.stopPropagation();
  }

  private _toNumber(value?: any, dflt?: number): number | undefined {
    if (value && typeof value === 'string') {
      return Number((value as string).replace(',', '.'));
    } else if (value && typeof value === 'number') {
      return Number(value);
    } else {
      return dflt;
    }
  }

  // Méthode générique pour gérer les changements
  subscribeToControlChanges(controlName: string, controlsToDisable: string[]) {
    this.formGroup.get(controlName)?.valueChanges.subscribe(value => {
      if (value) {
        controlsToDisable.forEach(ctrlName => {
          const control = this.formGroup.get(ctrlName);
          if (control) {
            control.setValue(false, { emitEvent: false }); // Ne pas émettre l'événement pour éviter une boucle infinie
            control.disable({ emitEvent: false });
          }
        });
      } else {
        controlsToDisable.forEach(ctrlName => this.formGroup.get(ctrlName)?.enable({ emitEvent: false }));
      }
    });
  }
}
